module.exports = __webpack_public_path__ + "static/media/008-circle-orange.03ea533c.svg";